import React, { useContext } from 'react';
import { Alert, Col, Form, Row } from 'react-bootstrap';
import AppContext from 'Utils/AppContext';
import { DataSourceContext } from 'DataSources/Utils';

/**
 * Environment switch for a data source, rendered directly under the source name by every
 * per-engine editor. It is the `readOnly` flag under a name that says what it means in
 * practice: a PROD source is the source of record — nobody masks, encrypts, deletes or
 * provisions into it. NON-PROD is the default and carries no restriction.
 *
 * The field is still `connection.readOnly` on the wire; only the label changed.
 * Non-admins can't flip it, so they get the explanatory alert instead of the switch.
 */
const ProdToggle = () => {
  const { connection, setConnection, setUnsavedChanges } = useContext(DataSourceContext);
  const { isAdmin } = useContext(AppContext);
  const isProd = !!connection.readOnly;

  if (!isAdmin) {
    return connection.readOnly ? (
      <Row className='text-left mb-3'>
        <Col>
          <Alert variant='warning' className='mb-0'>
            This data source is marked Prod. Only admins can edit it.
          </Alert>
        </Col>
      </Row>
    ) : null;
  }

  return (
    <Row className='text-left mb-3'>
      <Col>
        <Form.Check
          type='switch'
          id='read-only-toggle'
          label={isProd ? 'Prod' : 'Non-Prod'}
          checked={isProd}
          onChange={(e) => {
            setConnection({ ...connection, readOnly: e.target.checked });
            setUnsavedChanges(true);
          }}
        />
        <Form.Text className='text-muted'>
          When enabled, only admins can edit this data source; nobody can delete it or run masking/encryption jobs against it until an admin turns this off.
        </Form.Text>
      </Col>
    </Row>
  );
};

export default ProdToggle;
